import { useState } from 'react'
import { getBlock } from '@bst/blocks'
import { useEditorStore } from '../../store/editor.store'

export function LayersPanel() {
  const { page, selectedBlockId, selectedSectionId, selectBlock, selectSection, updateSection } = useEditorStore()
  const [editingSecId, setEditingSecId] = useState<string | null>(null)
  const [editingName, setEditingName] = useState('')

  if (page.sections.length === 0) {
    return (
      <div className="layers-panel">
        <div className="layer-empty"><p>Нет элементов</p></div>
      </div>
    )
  }

  function commitName(id: string) {
    updateSection(id, { name: editingName.trim() || undefined })
    setEditingSecId(null)
  }

  return (
    <div className="layers-panel">
      {page.sections.map((sec, i) => (
        <div key={sec.id} className="layer-section">
          <div
            className={`layer-section-header ${selectedSectionId === sec.id ? 'active' : ''}`}
            onClick={() => selectSection(sec.id)}
            onDoubleClick={(e) => { e.stopPropagation(); setEditingSecId(sec.id); setEditingName(sec.name ?? '') }}
          >
            <span className="layer-icon">▤</span>
            {editingSecId === sec.id ? (
              <input
                autoFocus
                className="layer-name-input"
                value={editingName}
                onChange={(e) => setEditingName(e.target.value)}
                onBlur={() => commitName(sec.id)}
                onKeyDown={(e) => { if (e.key === 'Enter') commitName(sec.id); if (e.key === 'Escape') setEditingSecId(null) }}
                onClick={(e) => e.stopPropagation()}
                style={{ flex: 1, fontSize: '12px', fontWeight: 600, background: 'var(--bg-3)', border: '1px solid var(--accent)', borderRadius: '3px', padding: '1px 4px', color: 'var(--text-primary)', outline: 'none' }}
              />
            ) : (
              <span className="layer-name" title="Двойной клик для переименования">{sec.name ?? `Секция ${i + 1}`}</span>
            )}
            <span className="layer-count">{sec.blocks.length}</span>
          </div>
          {sec.blocks.map((block) => {
            const def = getBlock(block.type)
            return (
              <div
                key={block.id}
                className={`layer-block-item ${selectedBlockId === block.id ? 'active' : ''}`}
                onClick={() => selectBlock(block.id)}
              >
                <span className="layer-indent" />
                <span className="layer-icon" style={{ fontSize: '11px', width: '16px', textAlign: 'center' }}>{def?.icon ?? '◻'}</span>
                <span className="layer-name">{def?.label ?? block.type}</span>
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
